import { createAsyncThunk } from '@reduxjs/toolkit';
import { scrollToTop } from '@/libs/helpers';
import { createOrder } from '../process/createOrder';
import { isLastStepSelector, nextStepSelector } from './selectors';
import { setStep } from './setStep';
export const goNextStep = createAsyncThunk('', async (_, { dispatch, getState }) => {
    const state = getState();
    const isLastStep = isLastStepSelector(state);
    if (isLastStep) {
        dispatch(createOrder());
        return;
    }
    const nextStep = nextStepSelector(state);
    if (!nextStep) {
        throw new Error('Next step not found');
    }
    dispatch(setStep(nextStep));
    scrollToTop();
});
